export default "__VITE_ASSET___mN_EzpA__"